import styles from './Benefits.module.scss';
import Slider from '#components/ui/Slider';
import BenefitCard from '#components/ui/BenefitCard';

type Props = {
  content: {
    title: string;
    text: string;
  }[];
};

const renderSlide = (item: { title: string; text: string }, index: number) => (
  <div className={`${styles.benefitsWrapper} ${styles.mobile}`}>
    <BenefitCard item={item} index={index} />
  </div>
);

const BenefitsMobile = ({ content }: Props) => {
  return (
    <div className={styles.sliderWrapper}>
      <Slider
        slides={content}
        renderSlide={renderSlide}
        slidesPerViewMobile="auto"
        sliderType="benefits"
        centeredSlides={false}
        scrollbar={true}
        slidesPerViewDesktop={3}
      />
    </div>
  );
};

export default BenefitsMobile;
